import Viewer from "./Viewer";

export * from "./webviewer";

export default Viewer;
